document.addEventListener('DOMContentLoaded', function() {

  // === Scroll Reveal ===
  try {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));
  } catch(e) { console.error('stoq-pre:', e); }

  // === Pain Section: Progressive darkening (one-way, never reverts) ===
  try {
    (function () {
      const pain = document.getElementById('pain');
      const cards = document.querySelectorAll('.pain-card');
      const deep = document.getElementById('painDeep');
      const stats = document.querySelectorAll('.pain-stat-item');
      let counted = false;
      let maxDepthReached = 0;

      // Card reveal
      const cardObs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) e.target.classList.add('visible');
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

      cards.forEach(c => cardObs.observe(c));
      if (deep) cardObs.observe(deep);
      stats.forEach(s => cardObs.observe(s));

      // Depth map: card index → depth level
      const depthMap = new Map();
      cards.forEach((c, i) => depthMap.set(c, Math.min(i + 1, 4)));
      if (deep) depthMap.set(deep, 5);

      // One-way darkening: only increase, never decrease
      const depthObs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const d = depthMap.get(e.target) || 0;
            if (d > maxDepthReached) {
              maxDepthReached = d;
              pain.setAttribute('data-depth', maxDepthReached);
            }
          }
        });
      }, { threshold: 0.4 });

      cards.forEach(c => depthObs.observe(c));
      if (deep) depthObs.observe(deep);

      // Counter animation
      function animateCount(el, target, duration) {
        const start = performance.now();
        function tick(now) {
          const progress = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased);
          if (progress < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }

      const countObs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting && !counted) {
            counted = true;
            animateCount(document.getElementById('painNum1'), 6, 1500);
            animateCount(document.getElementById('painNum2'), 52, 2000);
          }
        });
      }, { threshold: 0.5 });

      const stat1 = document.getElementById('painStat1');
      if (stat1) countObs.observe(stat1);
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === Solution: POP number + POD card reveals ===
  try {
    (function () {
      const popEls = ['solPopNum', 'solPopLabel', 'solPopDesc'].map(id => document.getElementById(id));
      const podCards = document.querySelectorAll('.sol-pod-card');

      const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) e.target.classList.add('visible');
        });
      }, { threshold: 0.3 });

      popEls.forEach(el => { if (el) obs.observe(el); });
      podCards.forEach(c => obs.observe(c));
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === Hero Particles (vacuum visual) ===
  try {
    (function () {
      const c = document.getElementById('heroParticles');
      if (!c) return;
      for (let i = 0; i < 35; i++) {
        const p = document.createElement('div');
        p.className = 'particle';
        p.style.left = (20 + Math.random() * 60) + '%';
        p.style.top = (50 + Math.random() * 50) + '%';
        p.style.setProperty('--dx', (Math.random() * 30 - 15) + 'px');
        p.style.animationDuration = (5 + Math.random() * 7) + 's';
        p.style.animationDelay = Math.random() * 6 + 's';
        const s = 2 + Math.random() * 4;
        p.style.width = s + 'px'; p.style.height = s + 'px';
        c.appendChild(p);
      }
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === CTA Section Particles ===
  try {
    (function () {
      const c = document.getElementById('ctaParticles');
      if (!c) return;
      for (let i = 0; i < 18; i++) {
        const p = document.createElement('div');
        p.className = 'particle';
        p.style.left = (10 + Math.random() * 80) + '%';
        p.style.top = (40 + Math.random() * 60) + '%';
        p.style.setProperty('--dx', (Math.random() * 20 - 10) + 'px');
        p.style.animationDuration = (6 + Math.random() * 8) + 's';
        p.style.animationDelay = Math.random() * 5 + 's';
        const s = 2 + Math.random() * 3;
        p.style.width = s + 'px'; p.style.height = s + 'px';
        c.appendChild(p);
      }
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === Glass 3D Card Carousel ===
  try {
    (function () {
      const cards = document.querySelectorAll('.glass-card');
      const dots = document.querySelectorAll('.glass-dot');
      const hint = document.getElementById('glassHint');
      const scalePoints = document.querySelectorAll('.glass-scale-point');
      const scaleFill = document.getElementById('glassScaleFill');
      const scaleCounter = document.getElementById('glassCounter');
      if (!cards.length) return;

      const total = cards.length;
      let current = 0;

      const cardData = [
        { temp: '-20\u2103', label: '\u51b7\u51cd\u4fdd\u5b58' },
        { temp: '5\u2103', label: '\u51b7\u8535\u4fdd\u5b58' },
        { temp: '5\u2103', label: '\u51b7\u8535\u4fdd\u5b58' },
        { temp: '600W', label: '\u30ec\u30f3\u30b8\u52a0\u71b1' },
        { temp: '180\u2103', label: '\u30aa\u30fc\u30d6\u30f3\u8abf\u7406' },
        { temp: '250\u2103', label: '\u30aa\u30fc\u30d6\u30f3\u8abf\u7406' }
      ];

      function getPos(idx) {
        const diff = idx - current;
        if (diff === 0) return 'center';
        if (diff === 1 || diff === -(total - 1)) return 'right';
        if (diff === -1 || diff === (total - 1)) return 'left';
        if (diff === 2 || diff === -(total - 2)) return 'far-right';
        return 'far-left';
      }

      function update() {
        cards.forEach((card, i) => {
          card.className = 'glass-card ' + getPos(i);
        });
        dots.forEach((d, i) => d.classList.toggle('active', i === current));

        // Update scale bar
        scalePoints.forEach((p, i) => p.classList.toggle('active', i === current));
        const fillPct = (current / (total - 1)) * 100;
        scaleFill.style.width = fillPct + '%';

        // Update counter
        scaleCounter.innerHTML = '<span>' + (current + 1) + '</span> / ' + total;

        // Update hint
        const nextIdx = (current + 1) % total;
        hint.innerHTML = 'Next: <span>' + cardData[nextIdx].temp + ' ' + cardData[nextIdx].label + '</span> \u2192';
      }

      function clearExpanded() {
        cards.forEach(c => c.classList.remove('glass-expanded'));
      }

      window.navGlassCarousel = function (dir) {
        clearExpanded();
        current = (current + dir + total) % total;
        update();
      };

      window.goToGlassCard = function (idx) {
        clearExpanded();
        current = idx;
        update();
      };

      cards.forEach(card => {
        card.addEventListener('click', () => {
          const idx = parseInt(card.dataset.index);
          if (idx === current) {
            card.classList.toggle('glass-expanded');
          } else {
            clearExpanded();
            current = idx;
            update();
          }
        });
      });

      let startX = 0, tracking = false;
      const track = document.getElementById('glassTrack');

      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        tracking = true;
      }, { passive: true });

      track.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 50) return;
        navGlassCarousel(dx < 0 ? 1 : -1);
      }, { passive: true });

      document.addEventListener('keydown', (e) => {
        const rect = document.getElementById('glassCarousel').getBoundingClientRect();
        if (rect.top > window.innerHeight || rect.bottom < 0) return;
        if (e.key === 'ArrowRight') navGlassCarousel(1);
        else if (e.key === 'ArrowLeft') navGlassCarousel(-1);
      });

      update();
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === Pump texture detail overlay with swipe + nav ===
  try {
    const pumpDetails = [
      {
        title: '思わず撫でたくなる、美しいツヤ感',
        desc: '手に取った瞬間、すっと馴染む滑らかな手触り。光をやわらかく映すツヤのある表面は、キッチンに置いておくだけで絵になります。毎日使うものだからこそ、見た目にも手触りにも妥協したくない。そんな方のために仕上げた一台です。'
      },
      {
        title: 'ボタンひとつで、真空スタート',
        desc: 'Qボタンを軽く押すだけで吸引開始。青いLEDが点灯し、真空が完了すると自動で停止します。操作はこれだけ。充電はUSB-Cで、フル充電から約1ヶ月お使いいただけます。'
      },
      {
        title: '直径36mm。片手で軽々。',
        desc: 'リップスティックよりわずかに太い程度のスリムボディ。重さはスマートフォンの半分以下。夜中でも使える静音設計なので、赤ちゃんが寝ている隣でも気になりません。'
      }
    ];

    let currentPumpIdx = 0;

    function updatePumpDetail(index, animate) {
      const items = document.querySelectorAll('.pump-texture-item');
      const img = items[index].querySelector('.pump-texture-img');
      const card = document.getElementById('pumpDetailCard');
      const dots = document.querySelectorAll('.pump-detail-dot');

      if (animate) {
        card.classList.add('sliding');
        setTimeout(() => {
          document.getElementById('pumpDetailImg').src = img.src;
          document.getElementById('pumpDetailTitle').textContent = pumpDetails[index].title;
          document.getElementById('pumpDetailDesc').textContent = pumpDetails[index].desc;
          dots.forEach((d, i) => d.classList.toggle('active', i === index));
          currentPumpIdx = index;
          card.classList.remove('sliding');
        }, 250);
      } else {
        document.getElementById('pumpDetailImg').src = img.src;
        document.getElementById('pumpDetailTitle').textContent = pumpDetails[index].title;
        document.getElementById('pumpDetailDesc').textContent = pumpDetails[index].desc;
        dots.forEach((d, i) => d.classList.toggle('active', i === index));
        currentPumpIdx = index;
      }
    }

    window.openPumpDetail = function(index) {
      const overlay = document.getElementById('pumpDetailOverlay');
      updatePumpDetail(index, false);
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    window.closePumpDetail = function(e) {
      if (e.target.closest('.pump-detail-card') && !e.target.closest('.pump-detail-close')) return;
      e.stopPropagation();
      const overlay = document.getElementById('pumpDetailOverlay');
      overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    window.navPumpDetail = function(dir, e) {
      e.stopPropagation();
      let next = currentPumpIdx + dir;
      if (next < 0) next = pumpDetails.length - 1;
      if (next >= pumpDetails.length) next = 0;
      updatePumpDetail(next, true);
    };

    window.goToPumpDetail = function(index, e) {
      e.stopPropagation();
      if (index === currentPumpIdx) return;
      updatePumpDetail(index, true);
    };

    // Swipe / flick support
    (function () {
      const overlay = document.getElementById('pumpDetailOverlay');
      if (!overlay) return;
      let startX = 0, startY = 0, tracking = false;

      overlay.addEventListener('touchstart', (e) => {
        if (e.target.closest('.pump-detail-nav') || e.target.closest('.pump-detail-close') || e.target.closest('.pump-detail-dot')) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      overlay.addEventListener('touchend', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.changedTouches[0].clientX - startX;
        const dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 50 || Math.abs(dy) > Math.abs(dx)) return;
        if (dx < 0) {
          window.navPumpDetail(1, e);
        } else {
          window.navPumpDetail(-1, e);
        }
      }, { passive: true });

      // Keyboard support
      document.addEventListener('keydown', (e) => {
        if (!overlay.classList.contains('active')) return;
        if (e.key === 'ArrowRight') window.navPumpDetail(1, e);
        else if (e.key === 'ArrowLeft') window.navPumpDetail(-1, e);
        else if (e.key === 'Escape') {
          overlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      });
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === Parallax on solution image ===
  try {
    (function () {
      const img = document.querySelector('.parallax-image');
      if (!img) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) img.classList.add('zoomed');
        });
      }, { threshold: 0.3 });
      obs.observe(img);
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // === FAQ Accordion ===
  try {
    window.toggleFaq = function(el) {
      const item = el.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    };
  } catch(e) { console.error('stoq-pre:', e); }

  // === Glass Card Lightbox ===
  try {
    (function () {
      const lightbox = document.createElement('div');
      lightbox.className = 'gc-lightbox';
      lightbox.id = 'gcLightbox';
      lightbox.innerHTML = '\
    <button class="gc-lightbox-close" id="gcLbClose">&times;</button>\
    <div class="gc-lb-container">\
      <button class="gc-lb-nav gc-lb-nav-prev" id="gcLbPrev">&#8249;</button>\
      <div class="gc-lb-card" id="gcLbCard">\
        <div id="gcLbImgWrap"></div>\
        <div class="gc-lb-body">\
          <p class="gc-lb-temp" id="gcLbTemp"></p>\
          <p class="gc-lb-usage" id="gcLbUsage"></p>\
          <p class="gc-lb-title" id="gcLbTitle"></p>\
          <p class="gc-lb-desc" id="gcLbDesc"></p>\
          <span class="gc-lb-callout" id="gcLbCallout" style="display:none;"></span>\
        </div>\
      </div>\
      <button class="gc-lb-nav gc-lb-nav-next" id="gcLbNext">&#8250;</button>\
      <p class="gc-lb-counter" id="gcLbCounter"></p>\
    </div>';
      document.body.appendChild(lightbox);

      const cards = document.querySelectorAll('.glass-card');
      let lbIdx = 0;
      let lbOpen = false;

      function getLbData(idx) {
        const card = cards[idx];
        const tempEl = card.querySelector('.glass-card-temp');
        const usageEl = card.querySelector('.glass-card-usage');
        const titleEl = card.querySelector('.glass-card-title');
        const descEl = card.querySelector('.glass-card-desc');
        const calloutEl = card.querySelector('.glass-card-callout');
        const imgEl = card.querySelector('.glass-card-img');
        const placeholderEl = card.querySelector('.glass-card-img-placeholder') || card.querySelector('.gc-endurance');

        return {
          temp: tempEl ? tempEl.textContent : '',
          tempColor: tempEl ? tempEl.style.color : '',
          usage: usageEl ? usageEl.textContent : '',
          title: titleEl ? titleEl.textContent : '',
          desc: descEl ? descEl.innerHTML : '',
          callout: calloutEl ? calloutEl.textContent : '',
          imgSrc: imgEl ? imgEl.src : null,
          placeholderHTML: !imgEl && placeholderEl ? placeholderEl.outerHTML : null
        };
      }

      function renderLb() {
        const d = getLbData(lbIdx);
        document.getElementById('gcLbTemp').textContent = d.temp;
        document.getElementById('gcLbTemp').style.color = d.tempColor;
        document.getElementById('gcLbUsage').textContent = d.usage;
        document.getElementById('gcLbTitle').textContent = d.title;
        document.getElementById('gcLbDesc').innerHTML = d.desc;

        const calloutEl = document.getElementById('gcLbCallout');
        if (d.callout) {
          calloutEl.textContent = d.callout;
          calloutEl.style.display = 'inline-block';
        } else {
          calloutEl.style.display = 'none';
        }

        const imgWrap = document.getElementById('gcLbImgWrap');
        if (d.imgSrc) {
          imgWrap.innerHTML = '<img class="gc-lb-img" src="' + d.imgSrc + '" alt="">';
        } else if (d.placeholderHTML) {
          const clone = document.createElement('div');
          clone.innerHTML = d.placeholderHTML;
          const el = clone.firstElementChild;
          el.style.aspectRatio = '4 / 3';
          imgWrap.innerHTML = '';
          imgWrap.appendChild(el);
        } else {
          imgWrap.innerHTML = '<div class="gc-lb-img-placeholder"><span>Photo</span></div>';
        }

        document.getElementById('gcLbCounter').innerHTML = '<span>' + (lbIdx + 1) + '</span> / ' + cards.length;
      }

      function openLb(idx) {
        lbIdx = idx;
        renderLb();
        lightbox.classList.add('open');
        document.body.style.overflow = 'hidden';
        lbOpen = true;
      }

      function closeLb() {
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
        lbOpen = false;
      }

      function navLb(dir) {
        lbIdx = (lbIdx + dir + cards.length) % cards.length;
        renderLb();
      }

      // Click center card to open lightbox
      cards.forEach(card => {
        card.addEventListener('click', () => {
          const idx = parseInt(card.dataset.index);
          if (card.classList.contains('center')) {
            openLb(idx);
          }
        });
      });

      document.getElementById('gcLbClose').addEventListener('click', closeLb);
      document.getElementById('gcLbPrev').addEventListener('click', () => navLb(-1));
      document.getElementById('gcLbNext').addEventListener('click', () => navLb(1));

      // Close on backdrop click
      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) closeLb();
      });

      // Keyboard nav
      document.addEventListener('keydown', (e) => {
        if (!lbOpen) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowRight') navLb(1);
        else if (e.key === 'ArrowLeft') navLb(-1);
      });

      // Swipe in lightbox
      let lbStartX = 0, lbTracking = false;
      const lbCard = document.getElementById('gcLbCard');

      lbCard.addEventListener('touchstart', (e) => {
        lbStartX = e.touches[0].clientX;
        lbTracking = true;
      }, { passive: true });

      lbCard.addEventListener('touchend', (e) => {
        if (!lbTracking) return;
        lbTracking = false;
        const dx = e.changedTouches[0].clientX - lbStartX;
        if (Math.abs(dx) < 50) return;
        navLb(dx < 0 ? 1 : -1);
      }, { passive: true });
    })();
  } catch(e) { console.error('stoq-pre:', e); }

  // ===== Temperature Animation (usp-glass endurance) =====
  try {
    (function() {
      const TA_HOLD_START = 800;
      const TA_RAMP_DURATION = 4000;
      const TA_HOLD_END = 1200;
      const TA_RAMP_START = TA_HOLD_START;
      const TA_RAMP_END = TA_RAMP_START + TA_RAMP_DURATION;
      const TA_END = TA_RAMP_END + TA_HOLD_END;
      const TA_MIN = -20, TA_MAX = 560, TA_RANGE = TA_MAX - TA_MIN;

      const $ = id => document.getElementById(id);
      const taEls = {
        glowCold: $('taGlowCold'), glowWarm: $('taGlowWarm'),
        glowHot: $('taGlowHot'), glowExtreme: $('taGlowExtreme'),
        edge: $('taEdgeGlow'), floor: $('taFloorGlow'),
        img: $('taGlassImg'),
        num: $('taTempNum'), label: $('taTempLabel'),
        bar: $('taBarFill'), wrap: $('taWrap')
      };
      const taMilestones = [
        { el: $('taMs0'), temp: -20 }, { el: $('taMs1'), temp: 5 },
        { el: $('taMs2'), temp: 100 }, { el: $('taMs3'), temp: 250 },
        { el: $('taMs4'), temp: 560 }
      ];

      const taMsNorm = [(5-TA_MIN)/TA_RANGE, (100-TA_MIN)/TA_RANGE, (250-TA_MIN)/TA_RANGE];

      function taEase(t) {
        let b = t < 0.5 ? 2*t*t : -1+(4-2*t)*t;
        for (const ms of taMsNorm) {
          const d = Math.abs(b - ms);
          if (d < 0.04) b += (ms - b) * (1 - (1 - (1 - d/0.04)*0.5)) * 0.3;
        }
        return Math.max(0, Math.min(1, b));
      }

      function taColor(t) {
        if (t<0) return {r:59,g:140,b:212};
        if (t<30) return {r:45,g:138,b:86};
        if (t<150) return {r:234,g:179,b:8};
        if (t<300) return {r:249,g:115,b:22};
        return {r:220,g:38,b:38};
      }
      function taHex(t) {
        if (t<0) return '#3B8CD4';
        if (t<30) return '#2D8A56';
        if (t<150) return '#EAB308';
        if (t<300) return '#F97316';
        return '#DC2626';
      }
      function taLabel(t) {
        if (t<0) return '冷凍保存';
        if (t<30) return '冷蔵保存';
        if (t<150) return 'レンジ加熱';
        if (t<300) return 'オーブン調理';
        return '耐熱ガラスの限界域';
      }

      function taRender(temp) {
        const c = taColor(temp);
        const i = Math.max(0, Math.min(1, (temp-TA_MIN)/TA_RANGE));
        const rgb = c.r+','+c.g+','+c.b;

        taEls.glowCold.style.opacity = temp<30 ? 0.25+i*0.1 : 0;
        taEls.glowWarm.style.opacity = (temp>=30&&temp<150) ? 0.2+i*0.3 : 0;
        taEls.glowHot.style.opacity = (temp>=150&&temp<300) ? 0.3+i*0.3 : 0;
        taEls.glowExtreme.style.opacity = temp>=300 ? 0.4+i*0.4 : 0;

        taEls.edge.style.background = 'rgba('+rgb+','+(0.15+i*0.55)+')';
        taEls.edge.style.opacity = 1;
        taEls.floor.style.background = 'rgba('+rgb+','+(0.1+i*0.4)+')';
        taEls.floor.style.opacity = 1;

        var ds = 10+i*35, dop = 0.3+i*0.5;
        taEls.img.style.filter =
          'brightness('+(0.85+i*0.55)+') saturate('+(0.7+i*0.8)+') '+
          'drop-shadow(0 0 '+ds+'px rgba('+rgb+','+dop+')) '+
          'drop-shadow(0 0 '+(ds*0.4)+'px rgba('+rgb+','+(dop*0.6)+'))';

        taEls.num.textContent = temp+'℃';
        taEls.num.style.color = taHex(temp);
        taEls.label.textContent = taLabel(temp);
        taEls.bar.style.width = ((temp-TA_MIN)/TA_RANGE*100)+'%';

        taMilestones.forEach(function(ms) {
          if (temp >= ms.temp) ms.el.classList.add('active');
          else ms.el.classList.remove('active');
        });
      }

      var taRunning = false;
      function taAnimate() {
        if (!taRunning) return;
        var start = performance.now();
        function frame(now) {
          if (!taRunning) return;
          var e = now - start;
          if (e < TA_HOLD_START) {
            taRender(-20);
            requestAnimationFrame(frame);
          } else if (e < TA_RAMP_END) {
            taRender(Math.round(TA_MIN + TA_RANGE * taEase((e-TA_RAMP_START)/TA_RAMP_DURATION)));
            requestAnimationFrame(frame);
          } else if (e < TA_END) {
            taRender(560);
            requestAnimationFrame(frame);
          } else {
            taRender(-20);
            setTimeout(taAnimate, 500);
          }
        }
        requestAnimationFrame(frame);
      }

      // IntersectionObserver: animate only when visible
      if (taEls.wrap) {
        taRender(-20);
        var taObs = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting && !taRunning) {
              taRunning = true;
              taAnimate();
            } else if (!entry.isIntersecting) {
              taRunning = false;
            }
          });
        }, { threshold: 0.3 });
        taObs.observe(taEls.wrap);
      }
    })();
  } catch(e) { console.error('stoq-pre:', e); }

});
